<template>
  <DockMap v-if="config?.dock?.id != undefined" :config="config" />
  <RcPlusMap v-if="config?.rcPlus?.id != undefined" :config="config" />
  <DroneMap v-if="config?.drone?.id != undefined" :config="config" />
  <Video_QrCode v-if="config?.qrCodeOpen != false" :config="config" />
</template>
<script>
import DockMap from "@/partials/Device/Template/Dock/DockMap.vue";
import RcPlusMap from "@/partials/Device/Template/Rc+/RcPlusMap.vue";
import DroneMap from "@/partials/Device/Template/Drone/DroneMap.vue";
import Video_QrCode from "@/partials/Video/Video_QrCode.vue";

export default {
  name: "Device_Info_Both",
  components: {
    DockMap,
    RcPlusMap,
    DroneMap,
    Video_QrCode,
  },
  setup() {
    return {
    };
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
};
</script>
